<script lang="ts" setup>
import { useErrorsStore } from '@common/stores/errors'
import { Button, Page } from '@dailycare-au/ui'
import { useHead } from '@unhead/vue'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

definePage({ meta: { title: '404 Not found' } })

const CONTACT_EMAIL = import.meta.env.VITE_DAILYCARE_EMAIL_ADDRESS

const errorsStore = useErrorsStore()
const { formattedErr } = storeToRefs(errorsStore)
const resolvedErr = computed(() => {
  if (formattedErr.value)
    return formattedErr.value

  return {
    title: '404 Not Found',
    message: 'The requested resource could not be found.',
  }
})

useHead({ title: () => resolvedErr.value.title })

const reloadWindow = () => window.location.reload()
</script>

<template>
  <Page class="grid place-items-center">
    <div class="flex flex-col gap-3 text-center items-center">
      <h1 class="text-6xl font-bold">
        {{ resolvedErr.title }}
      </h1>

      <p>{{ resolvedErr.message }}</p>

      <div class="flex items-center gap-4">
        <Button variant="secondary" size="sm" @click="reloadWindow">
          Reload page
        </Button>

        <Button v-if="CONTACT_EMAIL" variant="secondary" size="sm" as="a" :href="`mailto:${CONTACT_EMAIL}`">
          Contact DailyCare
        </Button>
      </div>
    </div>
  </Page>
</template>
